import * as Yup from 'yup';

export function registerYupMethods(): void {
  Yup.addMethod<Yup.StringSchema>(Yup.string, 'weekDayShiftExists', function (message: string) {
    return this.test('validateWeekdayShift', message, function () {
      // parsed to any because the yup type declaration is incorrect
      // Yup.TestContext does not have 'from' property typed, but in fact it exists
      const from = (this as any).from;
      // 'from' contains an array of objects holding values for each level of form shape
      // last element of this array will contain top level form shape that will give access to all values
      const form = from[from.length - 1];
      return (
        Boolean(
          Number(form?.value?.monday) ||
            Number(form?.value?.tuesday) ||
            Number(form?.value?.wednesday) ||
            Number(form?.value?.thursday) ||
            Number(form?.value?.friday) ||
            Number(form?.value?.saturday) ||
            Number(form?.value?.sunday),
        ) || this.createError({ path: this.path, message })
      );
    });
  });
}
